import { render, staticRenderFns } from "./rg-editor.vue?vue&type=template&id=f87fbf76&"
import script from "./rg-editor.vue?vue&type=script&lang=js&"
export * from "./rg-editor.vue?vue&type=script&lang=js&"
import style0 from "./rg-editor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports